const CARDS = [
  {
    id: 1,
    title: '91年国产影片专题',
    desc: '汇集91年出品的经典国产电影，涵盖剧情、喜剧、爱情等多种类型，重温那个年代的影像记忆。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20film%20poster%20aesthetic%20with%20warm%20sepia%20tones%2C%20classic%20movie%20reel%20and%20soft%20dramatic%20lighting%2C%20nostalgic%20cinema%20atmosphere%2C%20rich%20amber%20and%20deep%20crimson%20highlights%2C%20elegant%20composition&width=700&height=450&seq=card-91video-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产电视剧热播榜',
    desc: '整理当前最受欢迎的国产电视剧，从年代大剧到都市情感，精彩剧情一网打尽。',
    tag: '热播推荐',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20scene%20with%20soft%20ambient%20lighting%2C%20comfortable%20sofa%20and%20screen%20glow%2C%20modern%20entertainment%20setting%2C%20rich%20golden%20and%20crimson%20tones%2C%20inviting%20atmosphere&width=700&height=450&seq=card-91video-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产综艺欢乐盛宴',
    desc: '精选搞笑、竞技、音乐等多元国产综艺，让您在忙碌之余享受纯粹的娱乐放松时光。',
    tag: '综艺精选',
    image: 'https://readdy.ai/api/search-image?query=Bright%20dynamic%20stage%20lighting%20with%20colorful%20warm%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20vibrant%20amber%20and%20golden%20highlights%2C%20lively%20studio%20setting%2C%20festive%20mood&width=700&height=450&seq=card-91video-03&orientation=landscape',
  },
  {
    id: 4,
    title: '纪录片频道推荐',
    desc: '探索国产优秀纪录片，从自然人文到历史纪实，用镜头记录真实的中国故事与风貌。',
    tag: '深度内容',
    image: 'https://readdy.ai/api/search-image?query=Majestic%20natural%20landscape%20with%20warm%20golden%20hour%20lighting%2C%20documentary%20cinematography%20style%2C%20rich%20earth%20tones%20and%20soft%20atmospheric%20haze%2C%20vast%20scenic%20vista%2C%20elegant%20composition&width=700&height=450&seq=card-91video-04&orientation=landscape',
  },
  {
    id: 5,
    title: '高分国产影片合集',
    desc: '精心筛选豆瓣高分国产电影，口碑与品质兼备，每一部都值得收藏和反复观看。',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20film%20awards%20ceremony%20atmosphere%20with%20warm%20spotlight%20and%20golden%20decor%2C%20premium%20cinema%20aesthetic%2C%20rich%20crimson%20curtains%20and%20soft%20dramatic%20lighting%2C%20luxurious%20theater%20setting&width=700&height=450&seq=card-91video-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热门专题</h2>
          <p className="text-sm md:text-base text-foreground-500">探索91国产视频丰富的内容版图</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.slice(0, 3).map((card) => (
            <div key={card.id} className="bg-background-100 rounded-2xl overflow-hidden cursor-pointer group">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`91视频网站 - ${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2 whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-base font-bold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {CARDS.slice(3, 5).map((card) => (
            <div key={card.id} className="bg-background-100 rounded-2xl overflow-hidden cursor-pointer group flex flex-col sm:flex-row">
              <div className="sm:w-2/5 aspect-[3/2] sm:aspect-auto overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`91视频网站 - ${card.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2 self-start whitespace-nowrap">
                  {card.tag}
                </span>
                <h3 className="text-base font-bold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}